import { useTranslation } from 'react-i18next';
import { ConnectButton } from '@rainbow-me/rainbowkit';

const LastChanceCTA = () => {
  const { t } = useTranslation();

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="last-chance" className="section-x last-chance">
      <div className="dot-grid" />
      <div className="gold-orb gold-orb--primary last-chance__orb-a" />
      <div className="gold-orb gold-orb--deep last-chance__orb-b" />

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9 text-center">
            <div className="eyebrow eyebrow--center mb-3" data-aos="fade-up">
              <span>{t('lastChance.eyebrow')}</span>
            </div>
            <h2 className="section-heading last-chance__heading" data-aos="fade-up">
              {t('lastChance.titleLead')}{' '}
              <span className="gold-text">{t('lastChance.titleHighlight')}</span>{' '}
              {t('lastChance.titleTail')}
            </h2>
            <p className="section-subheading mb-4" data-aos="fade-up" data-aos-delay="80">
              {t('lastChance.subtitle')}
            </p>

            <div className="last-chance__cta" data-aos="fade-up" data-aos-delay="160">
              <ConnectButton.Custom>
                {({ account, openConnectModal, mounted }) => {
                  const ready = mounted;
                  if (!ready) return null;
                  if (!account) {
                    return (
                      <button
                        type="button"
                        className="tg-btn tg-btn-lg"
                        onClick={openConnectModal}
                      >
                        <i className="fas fa-wallet" />
                        {t('lastChance.ctaConnect')}
                        <i className="fas fa-arrow-right" />
                      </button>
                    );
                  }
                  return (
                    <button
                      type="button"
                      className="tg-btn tg-btn-lg"
                      onClick={() => scrollToSection('strategies')}
                    >
                      <i className="fas fa-vault" />
                      {t('lastChance.ctaStake')}
                      <i className="fas fa-arrow-right" />
                    </button>
                  );
                }}
              </ConnectButton.Custom>

              <a
                className="tg-btn-two tg-btn-lg"
                href="#security"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('security');
                }}
              >
                <i className="fas fa-file-contract" />
                {t('lastChance.ctaContract')}
              </a>
            </div>

            <div className="last-chance__meta mono" data-aos="fade-up" data-aos-delay="240">
              <span><i className="fas fa-check-circle" /> {t('lastChance.meta.minDeposit')}</span>
              <span><i className="fas fa-check-circle" /> {t('lastChance.meta.nonCustodial')}</span>
              <span><i className="fas fa-check-circle" /> {t('lastChance.meta.immutable')}</span>
              <span><i className="fas fa-check-circle" /> {t('lastChance.meta.audited')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LastChanceCTA;
